import Home from "./../components/Home";
import PaginaNaoEncontrada from "./../components/utils/PaginaNaoEncontrada";
import Dashboard from "./../components/dashboard/Dashboard";

import MenuParametrizacao from "@/components/Parametrizacao/Menu/Index";
import Parametrizacao from "@/components/Parametrizacao/Index";
import ParametrizacaoCompra from "@/components/Parametrizacao/Compra/Index";
import ParametrizacaoCompraCadastrosMotivos from "@/components/Parametrizacao/Compra/CadastrosMotivos/Index";
import ParametrizacaoDistribuicao from "@/components/Parametrizacao/Distribuicao/Index";
import ParametrizacaoDistribuicaoGrupoSeparacao from "@/components/Parametrizacao/Distribuicao/GrupoSeparacao";
import ParametrizacaoDistribuicaoTransporte from "@/components/Parametrizacao/Distribuicao/Transporte";
import ParametrizacaoDistribuicaoCalendarioSeparacao from "@/components/Parametrizacao/Distribuicao/Calendario";
import ParametrizacaoFilial from "@/components/Parametrizacao/Filial/Index";
import ParametrizacaoFilialGrupo from "@/components/Parametrizacao/Filial/Grupo";
import ParametrizacaoFornecedor from "@/components/Parametrizacao/Fornecedor/Index";
import ParametrizacaoUsuario from "@/components/Parametrizacao/Usuario/Index";
import ParametrizacaoUsuarioComprador from "@/components/Parametrizacao/Usuario/Comprador";

import Compra from "./../components/compra/Compra";
import Automatizador from "./../components/compra/automatizadorTarefas/Automatizador";
import DrpLogistica from "../components/drp/Index.vue";
import configDrpAutomatizado from "../components/drp/configDrpAutomatizado/Index";
import IndicadorStatusMensal from "../components/indicadores/StatusMensal/Index.vue";
import SlowMovingExcesso from "../components/indicadores/NoMovingV1/Index.vue";
import AclUser from "./../components/acl/Acl";
import PainelAdm from "./../components/acl/PainelAdm";
import Cfg from "./../components/cfg/Cfg";
import pedido from "./../components/pedido/pedido";
import Eventos from "./../components/pedido/Eventos";
import TipoEvento from "./../components/pedido/TipoEvento";
import statusProduto from "../components/indicadores/StatusProdutoV1/Index.vue";
import StatusProdutoV3 from "./../components/indicadores/StatusProdutoV3/Index";
import IndicadorNoMovingV2 from "./../components/indicadores/NoMovingV2/Index.vue";
import venda from "./../components/venda/venda";
import statusPerdaDeVendaPorRuptura from "../components/indicadores/PerdaVendaPorRupturas/Index.vue";
import FichaTecnicaProducao from "./../components/fichaTecnicaProducao/Index";
import CadastrosMotivos from "./../components/compra/CadastrosMotivos";
import Cadastros from "./../components/cadastros/Cadastros";
import CadastrosFornecedor from "./../components/cadastros/Fornecedor";
import controlePermissoes from "./../components/cadastros/ControlePermissoes";
import motivosComprasOportunidade from "./../components/compra/MotivosComprasOportunidade";
import Workflow from "./../components/workflow/compra/Index";
import wkfAutorizacao from "./../components/workflow/autorizacao/Index";
import VendasEventos from "./../components/Eventos/Index";
import percepcaoCompras from "../components/indicadores/PercepcaoCompras/Index.vue";
import atualizacaoSistema from "./../components/cfg/CfgAtualizacoesSistema";
import orcamentoConfiguracao from "./../components/orcamento/configuracao";
import orcamentoDashboard from "./../components/orcamento/dashboard";
import heranca from "./../components/heranca/Index";
import GrupoFiliais from "./../components/cadastros/GrupoFiliais";
import SistemasIntegracao from "./../components/cadastros/SistemasIntegracao";
import Sazonalidades from "./../components/cadastros/sazonalidade/Sazonalidade";
import mapeamentoDeFiliais from "../components/mapeamentoDeFiliais/Index";
import compras_por_departamentos from "../components/compra/departamentos/Index";
import ProdutosAnaliseMercado from "../components/imports/ProdutosAnaliseMercado/Index";
import indicadorStatusProduto from "./../components/indicadores/indicadorStatusProduto/IndicadorStatusProduto";
import PainelGestaoDoComprador from "@/components/indicadores/PainelGestaoComprador/Index";
import AnaliseCompraMateriaPrima from "../components/compra/materiaPrima/cadastro/Index";
import compraMateriaPrima from "../components/compra/materiaPrima/compra/Index.vue";
import CoberturaCompras from "../components/Parametrizacao/Cruds/Index";
import ListaDePreco from "@/components/compra/fornecedor/ListasDePreco/Index";
import Diagnostico from "@/components/Diagnostico/Index";
import curvasCriticidade from '@/components/Parametrizacao/CurvasCriticidade/Index.vue';
import CompraPorProdutosGerais from '@/components/compra/ProdutosGerais/Index';
import drpMapaDeSeparacao from '@/components/drp/MapaSeparacao/Index';
import CarteiraCompradores from '@/components/cadastros/CarteiraComprador/Index.vue';
import CarteiraV2Compradores from '@/components/cadastros/CarteiraV2Compradores/Index.vue';
import CoberturaEsegPorLocalidadeFornecedor from '@/components/compra/Coberturas/CoberturaEsegPorLocalidade/Index.vue';
import DrpListaSeparacao from '@/components/drp/ListaSeparacao/Crud/Index.vue';
import AnaliseParametrosProdutoDrp from '@/components/drp/AnaliseParametrosProdutoDrp/Index.vue';
import MixProdutosFilial from '@/components/MixProdutosFilial/Index.vue';
import Cotacoes from "@/components/webcotacao/Cotacoes.vue";

export const routes = [
  {
    path: "",
    name: "Home",
    component: Home
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard
  },
  {
    path: "/menu-parametrizacao",
    name: "MenuParametrizacao",
    component: MenuParametrizacao
  },
  {
    path: "/parametrizacao",
    name: "Parametrizacao",
    component: Parametrizacao,
    meta: { layout: 'parametrizacao' }
  },
  {
    path: "/parametrizacao/usuario",
    name: "ParametrizacaoUsuario",
    component: ParametrizacaoUsuario,
    meta: { layout: 'parametrizacao' }
  },
  {
    path: "/parametrizacao/usuario/comprador",
    name: "ParametrizacaoUsuarioComprador",
    component: ParametrizacaoUsuarioComprador,
    meta: { layout: 'parametrizacao' }
  },
  {
    path: "/parametrizacao/fornecedor",
    name: "ParametrizacaoFornecedor",
    component: ParametrizacaoFornecedor,
    meta: { layout: 'parametrizacao' }
  },
  {
    path: "/parametrizacao/filial",
    name: "ParametrizacaoFilial",
    component: ParametrizacaoFilial,
    meta: { layout: 'parametrizacao' }
  },
  {
    path: "/parametrizacao/filial/grupo",
    name: "ParametrizacaoFilialGrupo",
    component: ParametrizacaoFilialGrupo,
    meta: { layout: 'parametrizacao' }
  },
  {
    path: "/parametrizacao/distribuicao",
    name: "ParametrizacaoDistribuicao",
    component: ParametrizacaoDistribuicao,
    meta: { layout: 'parametrizacao' }
  },
  {
    path: "/parametrizacao/distribuicao/grupo-separacao",
    name: "ParametrizacaoDistribuicaoGrupoSeparacao",
    component: ParametrizacaoDistribuicaoGrupoSeparacao,
    meta: { layout: 'parametrizacao' }
  },
  {
    path: "/parametrizacao/distribuicao/transporte",
    name: "ParametrizacaoDistribuicaoTransporte",
    component: ParametrizacaoDistribuicaoTransporte,
    meta: { layout: 'parametrizacao' }
  },
  {
    path: "/parametrizacao/distribuicao/calendario",
    name: "ParametrizacaoDistribuicaoCalendarioSeparacao",
    component: ParametrizacaoDistribuicaoCalendarioSeparacao,
    meta: { layout: 'parametrizacao' }
  },
  {
    path: "/parametrizacao/compra",
    name: "ParametrizacaoCompra",
    component: ParametrizacaoCompra,
    meta: { layout: 'parametrizacao' }
  },
  {
    path: "/parametrizacao/compra/cadastros-motivos",
    name: "ParametrizacaoCompraCadastrosMotivos",
    component: ParametrizacaoCompraCadastrosMotivos,
    meta: { layout: 'parametrizacao' }
  },
  {
    path: "/parametrizacao/compra/coberturas",
    name: "CoberturaCompras",
    component: CoberturaCompras,
    meta: { layout: 'parametrizacao' }
  },
  {
    path: "/compra",
    name: "Compra",
    component: Compra
  },
  {
    path: "/automatizador",
    name: "Automatizador",
    component: Automatizador
  },
  {
    path: "/logistica",
    name: "drp",
    component: DrpLogistica
  },
  {
    path: "/logistica/separacao-automatica",
    name: "configDrpAutomatizado",
    component: configDrpAutomatizado
  },
  {
    path: "/logistica/mapa-separacao",
    name: "drpMapaDeSeparacao",
    component: drpMapaDeSeparacao
  },
  {
    path: "/logistica/analise-parametros-produto",
    name: "AnaliseParametrosProdutoDrp",
    component: AnaliseParametrosProdutoDrp
  },
  {
    path: "/indicadores",
    name: "IndicadorStatusMensal",
    component: IndicadorStatusMensal
  },
  {
    path: "/acl",
    name: "acl",
    component: AclUser
  },
  {
    path: "/acl/adm/painel",
    name: "painel-adm",
    component: PainelAdm
  },
  {
    path: "/cotacoes/listar-cotacoes",
    name: "LitarCotacoes",
    component: Cotacoes
  },
  {
    path: "/configuracoes",
    name: "cfg",
    component: Cfg
  },
  {
    path: "/pedidos",
    name: "pedido",
    component: pedido
  },
  {
    path: "/slow_moving_excesso",
    name: "SlowMovingExcesso",
    component: SlowMovingExcesso
  },
  {
    path: "/compras_eventos",
    name: "Eventos",
    component: Eventos
  },
  {
    path: "/cadastro_tipo_evento",
    name: "TipoEvento",
    component: TipoEvento
  },
  {
    path: "/status_produto",
    name: "statusProduto",
    component: statusProduto
  },
  {
    path: "/indicadores/status-produto",
    name: "StatusProdutoV3",
    component: StatusProdutoV3
  },
  {
    path: "/indicadores/no-moving",
    name: "indicadorNoMovingV2",
    component: IndicadorNoMovingV2
  },
  {
    path: "/rentabilidade_de_fornecedores",
    name: "venda",
    component: venda
  },
  {
    path: "/status_perda_venda_ruptura",
    name: "statusPerdaDeVendaPorRuptura",
    component: statusPerdaDeVendaPorRuptura
  },
  {
    path: "/ficha_tecnica_producao",
    name: "FichaTecnicaProducao",
    component: FichaTecnicaProducao
  },
  {
    path: "/cadastros_motivos",
    name: "CadastrosMotivos",
    component: CadastrosMotivos
  },
  {
    path: "/cadastros/usuarios",
    name: "Cadastros",
    component: Cadastros
  },
  {
    path: "/cadastros/fornecedor",
    name: "CadastrosFornecedor",
    component: CadastrosFornecedor
  },
  {
    path: "/controle_permissoes",
    name: "controlePermissoes",
    component: controlePermissoes
  },
  {
    path: "/motivos_compras_oportunidade",
    name: "motivosComprasOportunidade",
    component: motivosComprasOportunidade
  },
  {
    path: "/workflow/configuracoes",
    name: "Workflow",
    component: Workflow
  },
  {
    path: "/workflow/autorizacao",
    name: "wkfAutorizacao",
    component: wkfAutorizacao
  },
  {
    path: "/percepcao_compras",
    name: "percepcaoCompras",
    component: percepcaoCompras
  },
  {
    path: "/atualizacao_sistema",
    name: "atualizacaoSistema",
    component: atualizacaoSistema
  },
  {
    path: "/orcamento/configDrpAutomatizado",
    name: "orcamentoConfiguracao",
    component: orcamentoConfiguracao
  },
  {
    path: "/orcamento/dashboard",
    name: "orcamentoDashboard",
    component: orcamentoDashboard
  },
  {
    path: "/eventos",
    name: "eventos",
    component: VendasEventos
  },
  {
    path: "/heranca",
    name: "heranca",
    component: heranca
  },
  {
    path: "/cadastros/grupo_filiais",
    name: "grupoFiliais",
    component: GrupoFiliais
  },
  {
    path: "/cadastros/sistemas_de_integracao",
    name: "sistemasIntegracao",
    component: SistemasIntegracao
  },
  {
    path: "/produtos/sazonalidades",
    name: "sazonalidades",
    component: Sazonalidades
  },
  {
    path: "/filiais/mapeamento",
    name: "mapeamentoDeFiliais",
    component: mapeamentoDeFiliais
  },
  {
    path: "/compras/grupos/:id_grupo/filiais/:id_filial/departamentos/:id_departamento",
    name: "compras_por_departamentos",
    component: compras_por_departamentos
  },
  {
    path: "/imports/produtos-analise-mercado",
    name: "ProdutosAnaliseMercado",
    component: ProdutosAnaliseMercado
  },
  {
    path: "/indicador_status_produto",
    name: "indicadorStatusProduto",
    component: indicadorStatusProduto
  },
  {
    path: '/indicadores/gestao-do-comprador/painel',
    name: 'indicadores.gestao_do_comprador',
    component: PainelGestaoDoComprador
  },
  {
    path: "/analise-compra-materia-prima",
    name: "AnaliseCompraMateriaPrima",
    component: AnaliseCompraMateriaPrima
  },
  {
    path: "/compras/materia-prima",
    name: "compraMateriaPrima",
    component: compraMateriaPrima
  },
  {
    path: "/parametrizacao/coberturas",
    name: "CoberturaCompras",
    component: CoberturaCompras
  },
  {
    path: "/fornecedores/listas-de-preco",
    name: "ListaDePreco",
    component: ListaDePreco
  },
  {
    path: "/diagnostico",
    name: "Diagnostico",
    component: Diagnostico
  },
  {
    path: "/curvas/criticidade",
    name: "curvasCriticidade",
    component: curvasCriticidade
  },
  {
    path: "/compras/produtos",
    name: "CompraPorProdutosGerais",
    component: CompraPorProdutosGerais
  },
  {
    path: "/carteira/compradores",
    name: "CarteiraCompradores",
    component: CarteiraCompradores
  },
  {
    path: "/carteiras/v2/compradores",
    name: "CarteiraV2Compradores",
    component: CarteiraV2Compradores
  },
  {
    path: "/coberturas/curvas/estoque-seguranca",
    name: "CoberturaEsegPorLocalidadeFornecedor",
    component: CoberturaEsegPorLocalidadeFornecedor
  },
  {
    path: "/drp/lista-separacao",
    name: "DrpListaSeparacao",
    component: DrpListaSeparacao
  },
  {
    path: "*",
    name: "Not found",
    component: PaginaNaoEncontrada
  },
  {
    path: "/mix-produtos-filial",
    name: "MixProdutosFilial",
    component: MixProdutosFilial
  },
]
